var firebase = null;

$(document).on('firebase.initialized', function() {
    firebase = window.firebase;
    _init();
});

var COOKIES = require('src/interlock/no-ui/utils/cookies/cookies');
var profileValidator = require('./validation');
var consoleWarn = global.console.warn;

var actionHadlers = {
    signIn: [],
    signOut: []
};

function on(action, cb) {
    var handlers = actionHadlers[action];

    if (!handlers) {
        handlers = [];
    }
    handlers.push(cb);
}

function onSignIn(user) {
    COOKIES.setItem('fb_accessToken', user._lat);
    COOKIES.setItem('fb_refreshToken', user.refreshToken);

    actionHadlers.signIn.forEach(function(cb) {
        cb(user);
    });
}

function onSignOut() {
    COOKIES.removeItem('fb_accessToken');
    COOKIES.removeItem('fb_refreshToken');

    actionHadlers.signOut.forEach(function(cb) {
        cb();
    });
}

function sendEmailVerification(user) {
    if (user && !user.emailVerified) {
        user.sendEmailVerification();
    }
}

function _init() {
    $(document).on('click', '.sign-drawer .google-button', function() {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('profile');
        provider.addScope('email');

        return firebase.auth().signInWithPopup(provider).then(function(result) {
            onSignIn(result.user);
        }).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    $(document).on('click', '.sign-drawer .facebook-button', function() {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('public_profile');
        provider.addScope('email');

        return firebase.auth().signInWithPopup(provider).then(function(result) {
            onSignIn(result.user);
        }).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    $(document).on('click', '[data-action="sign-out"]', function(e) {
        e.preventDefault();

        return firebase.auth().signOut().then(onSignOut).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            onSignIn(user);
        } else {
            onSignOut();
        }
    });
}

module.exports = {
    on: on,
    onSignIn: onSignIn,
    sendEmailVerification: sendEmailVerification
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/profile-helper.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14